import React, { useState } from 'react';
import CompressionSettings from './CompressionSettings';
import './Settings.css';

const SETTING_SECTIONS = [
  { id: 'compression', label: 'Screenshot Capture', icon: '📸' },
  { id: 'general', label: 'General', icon: '⚙️' },
  { id: 'network', label: 'Network', icon: '🌐' },
  { id: 'appearance', label: 'Appearance', icon: '🎨' },
  { id: 'advanced', label: 'Advanced', icon: '🔧' },
];

function Settings({ isOpen, onClose }) {
  const [activeSection, setActiveSection] = useState('compression');

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div 
      className="settings-overlay" 
      onClick={handleOverlayClick}
      onKeyDown={handleKeyDown}
      role="dialog"
      aria-modal="true"
      aria-labelledby="settings-title"
    >
      <div className="settings-modal">
        <header className="settings-header">
          <h2 id="settings-title">Settings</h2>
          <button 
            className="settings-close" 
            onClick={onClose}
            aria-label="Close settings"
          >
            ×
          </button>
        </header>

        <div className="settings-body">
          <aside className="settings-sidebar">
            <nav>
              {SETTING_SECTIONS.map((section) => (
                <button
                  key={section.id}
                  className={`settings-nav-item ${
                    activeSection === section.id ? 'active' : ''
                  }`}
                  onClick={() => setActiveSection(section.id)}
                >
                  <span className="settings-nav-icon">{section.icon}</span>
                  <span className="settings-nav-label">{section.label}</span>
                </button>
              ))}
            </nav>
          </aside>

          <main className="settings-content">
            {activeSection === 'compression' && <CompressionSettings />}
            {activeSection === 'general' && <GeneralSettings />}
            {activeSection === 'network' && <NetworkSettings />}
            {activeSection === 'appearance' && <AppearanceSettings />}
            {activeSection === 'advanced' && <AdvancedSettings />}
          </main>
        </div>

        <footer className="settings-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </footer>
      </div>
    </div>
  );
}

// Placeholder components for future sections
function GeneralSettings() {
  return (
    <div className="settings-section">
      <h3>General Settings</h3>
      <p className="text-muted">Coming soon...</p>
    </div>
  );
}

function NetworkSettings() {
  return (
    <div className="settings-section">
      <h3>Network Settings</h3>
      <p className="text-muted">Coming soon...</p>
    </div>
  );
}

function AppearanceSettings() {
  return (
    <div className="settings-section">
      <h3>Appearance Settings</h3>
      <p className="text-muted">Coming soon...</p>
    </div>
  );
}

function AdvancedSettings() {
  return (
    <div className="settings-section">
      <h3>Advanced Settings</h3>
      <p className="text-muted">Coming soon...</p>
    </div>
  );
}

export default Settings;

